import { OvertimeRequest } from "./OvertimeRequest";

export class HrAdminOvertimeRequest extends OvertimeRequest {
    isCompleted: boolean;
    
    constructor(overtimeRequest: OvertimeRequest) {
        super(
            overtimeRequest.id, 
            overtimeRequest.employeeId, 
            overtimeRequest.overtimeDate, 
            overtimeRequest.overtimeTypeId,
            overtimeRequest.description, 
            overtimeRequest.filePath,
            overtimeRequest.readAndAprroved, 
            overtimeRequest.fileList,
            overtimeRequest.branchCode,
            overtimeRequest.startTime,
            overtimeRequest.endTime,
            overtimeRequest.isRestDay,
            overtimeRequest.projectCode,
            overtimeRequest.tenantCode
        );
    }
}